export const cellStyles = {
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    alignItems:'center',
    padding:'4px 6px 4px 6px',
    height:'40px',
    color: '#444',
}
export const statusList = [{ id: 0, name: 'Inactive', translationKey: 'gsInactive' }, { id: 1, name: 'Active', translationKey: 'gsActive' }]
export const ctreditLimitList = [{ id: 0, name: 'Limited', translationKey: 'limited' }, { id: 1, name: 'No Limit', translationKey: 'noLimit' }]
export const commissionList = [{ id: 0, name: 'Percentage', translationKey: 'percentage' }, { id: 1, name: 'Amount', translationKey: 'amount' }]
export const billingUnitList =[{id: -1, name: 'All', translationKey: 'gsAll'},{ id: 1, name: 'Per KG', translationKey: 'gsPerKg' },{ id: 2, name: 'Per Quantity', translationKey: 'perQuantity' },
    // { id: 3, name: 'Per LR' },
    { id: 4, name: 'Per Kg-Km', translationKey: 'perKgKmHyphen' },]
export const serviceTypeList = [{id: -1, name: 'All', translationKey: 'gsAll'},{ id: 1, name: 'By Bus', translationKey: 'byBus' },{ id: 2, name: 'By Cargo', translationKey: 'byCargo' },{ id: 3, name: 'By Express Cargo', translationKey: 'byExpressCargo' },{ id: 4, name: 'By Partner Cargo', translationKey: 'byPartnerCargo' },]
export const statusListWithAll = [{id: -1, name: 'All', translationKey: 'gsAll'},{ id: 0, name: 'Inactive', translationKey: 'gsInactive' }, { id: 1, name: 'Active', translationKey: 'gsActive' }]
